import { CreateAccountValuesType } from "../types";

export const createAccountInitialValues: CreateAccountValuesType = {
  email: "",
  password: "",
};
